export default __webpack_public_path__ + "static/media/logo.998c447e.png";